import { render } from "./AdminVideoUpload.vue?vue&type=template&id=6a778b38&scoped=true&ts=true"
import script from "./AdminVideoUpload.vue?vue&type=script&lang=ts"
export * from "./AdminVideoUpload.vue?vue&type=script&lang=ts"

import "./AdminVideoUpload.vue?vue&type=style&index=0&id=6a778b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a778b38"]])

export default __exports__